import React from 'react'
// libs
import { Field } from 'redux-form'
import styled from 'styled-components'
// components
import DatePicker, { CustomDatePickerProps } from 'components/FormElements/DatePicker'
import ErrorMessage from 'components/UI/ErrorMessage'
import FormControl, { FormControlOwnProps } from '@mui/material/FormControl'
// views
import { ErrorMessageWrapper } from 'components/UI/ErrorMessage'
// types
import { Validators } from 'utils/validators'
import { WrappedFieldProps } from 'redux-form/lib/Field'

const ReduxDatePickerWrapper = styled(FormControl)`
  && {
    position: relative;
  }
`

interface Props extends Omit<CustomDatePickerProps, 'onChange' | 'onError'> {
  variant?: FormControlOwnProps['variant']
  validate?: Validators
}

const renderComponent = ({
  meta: { touched, error },
  input: { value, onChange, name },
  variant,
  ...rest
}: Props & WrappedFieldProps) => {
  const isError = touched && !!error

  return (
    <ReduxDatePickerWrapper
      fullWidth
      margin='none'
      variant={variant}
      data-testid={name}
      className={`date-picker-wrapper`}>
      <DatePicker {...rest} error={isError} value={value} onChange={onChange} />
      {isError && (
        <ErrorMessageWrapper>
          <ErrorMessage>{error}</ErrorMessage>
        </ErrorMessageWrapper>
      )}
    </ReduxDatePickerWrapper>
  )
}

const ReduxDatePicker: React.FC<Props> = (props) => <Field {...props} component={renderComponent} />

export default ReduxDatePicker
